import { FechaFunctionsService } from '@/utils/functions.service';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.scss']
})
export class DetalleComponent {
  base64: any;
  pedido: any;
  summProductos: number;
  tenant: any;
  @ViewChild('content') content: TemplateRef<any>;

  constructor(private modalService: NgbModal,
    private route: ActivatedRoute,
    public generalService: GeneralService,
    protected sanitizer: DomSanitizer,
    public loadingService: LoadingService,
    public Func: FechaFunctionsService) {
  }

  ngOnInit() {
    try {
      this.loadingService.setLoading(true)
      this.route.paramMap.subscribe(async params => {
        const parametroCodificado = params.get('parametro');
        let res = await this.generalService.getObtiene("pedido/public", parametroCodificado)
        this.pedido = res.data;
        this.tenant = res.tenant[0];
        this.summProductos = this.pedido.detalle_pedidos.map(e => Number(e.cantidad) * e.valor)
          .reduce((a, b) => a + b, 0);
        let res2 = await this.generalService.getObtiene("documentos/ticket-public", parametroCodificado)
        this.base64 = this.sanitizer.bypassSecurityTrustResourceUrl(res2.data.base64);
        this.loadingService.setLoading(false)
      });
    } catch (error) {
      console.log(error)
    }
  }

  GeneraPdf() {
    this.modalService.open(this.content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {
    }, (reason) => {
      //Cerrasdo por X, ESC, backdrop
    });
  }
}
